/** A card the guest must correct before it is tokenized; its message is a booking i18n key. */
export class CardInputError extends Error {}

/** "4509 9535 6623 3704": the digits typed, grouped by four. */
export function formatCardNumber(value: string): string {
  const digits = value.replace(/\D/g, '');
  return digits.replace(/(.{4})/g, '$1 ').trim();
}

/** "11/30": the digits typed as MM/YY. */
export function formatExpiry(value: string): string {
  const digits = value.replace(/\D/g, '');
  if (digits.length >= 3) {
    return digits.slice(0, 2) + '/' + digits.slice(2, 4);
  }
  return digits;
}
